import { defineStore } from '/src/core/store';
import { useDeviceStore } from './useDeviceStore';
import { getEmployee } from '/src/apis/employees.js';

export const useEmployeeStore = defineStore('employees', {
	state: () => ({
		employees: [],
		employeesLoading: true,
		employeesProgress: 0,
	}),
	persist: {
		storage: 'native',
		pick: ['employees'],
		migrate: 'local',
	},
	actions: {
		setEmployees (employees) {
			this.employees = employees;
		},
		addEmployee (employee) {
			const index = this.employees.findIndex(e => e?.id === employee.id);
			if (index < 0) {
				this.employees.push(employee);
			}
		},
		removeEmployee (employeeId) {
			const index = this.employees.findIndex(employee => employee?.id === employeeId);
			if (index >= 0) {
				this.employees.splice(index, 1);
			}
		},
		updateEmployee (employeeId, update) {
			const index = this.employees.findIndex(employee => employee.id === employeeId);

			if (index >= 0) {
				const firstName = update?.firstName || update?.employeeFullName?.firstName || this.employees[index].firstName;
				const lastName = update?.lastName || update?.employeeFullName?.lastName || this.employees[index].lastName;

				this.employees[index] = {
					...this.employees[index],
					...update,
					firstName,
					lastName,
				};
			}
		},
		hasEmployee (employeeId) {
			return this.employees.findIndex(employee => employee?.id === employeeId) >= 0;
		},
		setEmployeesLoading (bool) {
			this.employeesLoading = bool;
		},
		setEmployeesProgress (progress) {
			this.employeesProgress = progress;
		},
		reset () {
			this.setEmployees([]);
		},
	},
	sockets: {
		EmployeeCreated (data) {
			this.addEmployee({
				...data,
				id: data.employeeId,
			});
		},
		EmployeeUpdated (data) {
			this.updateEmployee(data.employeeId, {
				...data,
				firstName: data.employeeFullName?.firstName,
				lastName: data.employeeFullName?.lastName,
			});
		},
		EmployeeNFCUpdatedSocketData ({ data }) {
			this.updateEmployee(data.employeeId, data);
		},
		EmployeeDeleted ({ employeeId }) {
			this.removeEmployee(employeeId);
		},
		EmployeeWorkStatusUpdated ({ employeeId, newStatus }) {
			this.updateEmployee(employeeId, { workStatus: newStatus.value });
		},
		CompanyDeviceDeleted () {
			this.reset();
		},
		async EmployeeOfficeUpdatedSocketData ({ data }) {
			const { companyIds, officeIds } = useDeviceStore();

			if (!companyIds.value?.includes(data.companyId)) {
				return;
			}
			if (!officeIds.value?.includes(data.officeId)) {
				return;
			}

			if (data.action === 'unassigned') {
				this.removeEmployee(data.employeeId);
				return;
			}

			const employee = await getEmployee({
				companyIds: companyIds.value,
				employeeId: data.employeeId,
			});

			this.addEmployee(employee);
		},
	},
});
